import React, { memo, ReactNode } from 'react';
import { Heading } from '../../general/heading';
import { AccordionItem } from '../accordion/accordion-item';

import styles from './footer.module.sass';

export const FooterAccordionColumn = memo(
  ({ title, headingId, links }: { title: string; headingId: string; links: ReactNode[] }) => {
    const items = links.map((link, index) => {
      const key = `${index}-item`;
      return (
        <li className={styles.footerAccordionColumnListItem} role="listitem" key={key}>
          {link}
        </li>
      );
    });

    const heading = (
      <Heading level={3} id={headingId} className={styles.footerAccordionColumnTitle}>
        {title}
      </Heading>
    );

    const content = (
      <ul aria-labelledby={headingId} className={styles.footerAccordionColumnLinks}>
        {items}
      </ul>
    );

    return (
      <div className={styles.footerAccordionColumn}>
        <div className={styles.mobile}>
          <AccordionItem
            className={styles.footerAccordionColumnItem}
            label={heading}
            itemKey={headingId}
          >
            {content}
          </AccordionItem>
        </div>
        <div className={styles.desktop}>
          {heading}
          {content}
        </div>
      </div>
    );
  },
);
